<template>
  <div>
    <div
      class="logo"
      style="cursor:pointer"
      @click="$router.push({ path: '/home' })"
    >
      <img src="~static/images/logoone.png" alt="logo" />
      <!-- <img src="~assets/404_images/404.png" alt="logo" /> -->
      <span>CMS核心管理系统</span>
    </div>
    <div class="login-info">
      <div class="user-profile">
        <img
          src="/static/images/avator.jpg"
          class="profile-thumb"
          alt="User Thumb"
        /><span class="status-label"></span>
      </div>
      <div class="user-name">{{ loginName }}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loginName: JSON.parse(window.localStorage.getItem("userInfo")).loginName
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/layout/components/SideInfo.vue